<template>
  <div ref="cell" class="grid-view__cell">
    <div class="grid-field-button">
      <Button
        v-if="hasWorkflowActions"
        type="secondary"
        size="tiny"
        :loading="dispatching"
        @click="dispatchWorkflowActions"
      >
        {{ field.label }}
      </Button>
      <Button v-else type="secondary" size="tiny" disabled>
        {{ field.label }}
      </Button>
      <ButtonFieldConfirmModal
        v-if="buttonFieldConfirmEnabled"
        ref="buttonFieldConfirmModal"
        :message="buttonFieldConfirmMessage"
        :confirm-label="field.label"
        @confirm="onButtonFieldConfirm"
        @cancel="onButtonFieldConfirmCancel"
      />
    </div>
  </div>
</template>

<script>
import buttonField from '@baserow/modules/database/mixins/buttonField'
import SearchHighlightedText from '@baserow/modules/database/components/view/grid/fields/SearchHighlightedText'
import ButtonFieldConfirmModal from '@baserow/modules/database/components/field/ButtonFieldConfirmModal'

export default {
  name: 'FunctionalGridViewFieldButtonField',
  mixins: [buttonField],
  props: {
    row: { type: Object, required: true },
    field: { type: Object, required: true },
    value: { type: null, default: null },
    searchTerm: {
      type: String,
      required: false,
      default: '',
    },
  },
}
</script>
